import { render, staticRenderFns } from "./MaterialSelectorModal.vue?vue&type=template&id=ef4ce43e"
import script from "./MaterialSelectorModal.vue?vue&type=script&lang=js"
export * from "./MaterialSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports